import type * as DB from 'interfaces/database';

export type OfferingPageAssetKind = 'mask' | 'overlay';

export interface OfferingPageAssetModel {
	id: number | string;
	offeringid: DB.OfferingModel['id'];
	// Matches the app's zero-based page index from ProductStateModule.getPageIndex().
	pageindex: number;
	url: string;
}

export interface OfferingPageAssetSource<Model extends OfferingPageAssetModel> {
	cacheKey: string;
	model?: Model;
	url: string;
}

export function findOfferingPageAssetModel<Model extends OfferingPageAssetModel>(
	models: ReadonlyArray<Model>,
	offeringId: DB.OfferingModel['id'],
	// Zero-based page index from ProductStateModule.getPageIndex().
	pageIndex: number,
): Model | undefined {
	return models.find((model) => (
		model.offeringid === offeringId
		&& model.pageindex === pageIndex
	));
}

export function resolveOfferingPageAssetSource<Model extends OfferingPageAssetModel>({
	assetKind,
	fallbackUrl,
	models,
	offeringId,
	pageIndex,
}: {
	assetKind: OfferingPageAssetKind;
	fallbackUrl?: string | null;
	models: ReadonlyArray<Model>;
	offeringId: DB.OfferingModel['id'];
	pageIndex: number;
}): OfferingPageAssetSource<Model> | null {
	const model = findOfferingPageAssetModel(
		models,
		offeringId,
		pageIndex,
	);

	if (model) {
		return {
			cacheKey: `${assetKind}:${String(model.id)}`,
			model,
			url: model.url,
		};
	}

	if (!fallbackUrl) {
		return null;
	}

	return {
		cacheKey: `${assetKind}:legacy:${offeringId}`,
		url: fallbackUrl,
	};
}
